Text of the choice displayed to the candidate.
